function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#243165;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16,32c8.8,0,16-7.2,16-16c0-8.8-7.2-16-16-16C7.2,0,0,7.2,0,16C0,24.8,7.2,32,16,32z M10.1,8.5 c0.3-2,2.4-3.6,4.5-2.8c0.1,0,0.2,0,0.2,0c1.3-1.3,3-1.2,4.5-0.5c2.1,1.1,3.1,3.2,2.7,5.6c0,0.3-0.1,0.6-0.1,0.9 c-0.4-0.9-1.1-1.3-2-1.5c-0.5-0.1-1-0.2-1.6-0.2c-0.9,0-1.7,0.1-2.6-0.1c-0.3-0.1-0.5-0.1-0.8-0.2c-0.8-0.3-1.2-0.9-1.2-1.9 c-1.7,0.8-3,2-3.7,3.9c0-0.1,0-0.2,0-0.3C10.1,10.4,9.9,9.5,10.1,8.5z M9.1,13.4c0.1-0.3,0.3-0.5,0.5-0.7c0.1-0.1,0.2-0.1,0.3-0.1 c0.5,0,0.8-0.1,0.9-0.6c0.3-1,0.9-1.7,1.7-2.4C12.7,9.3,13,9.1,13.2,9c0.7,1.4,2,1.7,3.4,1.8c0.8,0.1,1.7,0,2.5,0 c0.5,0,0.9,0.2,1.4,0.4c0.3,0.1,0.6,0.4,0.7,0.8c0.1,0.3,0.4,0.5,0.7,0.5c0.3,0,0.6,0.1,0.7,0.4c0.3,0.5,0.4,1.1,0.3,1.6 c-0.2,0.9-0.6,1.7-1.5,2.1c-0.5,0.2-0.6,0.4-0.8,0.8c-0.5,1.1-1.2,2.1-2.2,2.8c-1.7,1.4-3.5,1.3-5.1-0.2c-0.9-0.8-1.6-1.8-2.1-2.9 c-0.1-0.3-0.2-0.5-0.6-0.6c-0.5-0.1-0.9-0.5-1.1-0.9C9.1,15,8.9,14.2,9.1,13.4z M6.1,23c0-0.9,0.6-1.6,1.5-1.9 c1.3-0.4,2.6-0.8,3.9-1.2c0.2-0.1,0.3,0,0.5,0.1c0.5,0.5,1,1,1.6,1.4c1.4,0.9,2.9,1,4.4,0.2c0.8-0.4,1.4-0.9,2-1.6 c0.1-0.2,0.3-0.2,0.4-0.1c0.3,0.1,0.5,0.2,0.8,0.2c1.1,0.3,2.2,0.6,3.3,1c0.8,0.3,1.3,0.9,1.3,1.7c0,0.5,0,1,0,1.5 c0,0.6,0,1.1-0.1,1.7H6.2C6.1,25.1,6.1,24,6.1,23z"
});

var SvgUsuario = function SvgUsuario(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsuario, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usuario.ffe86f40.svg";
export { ForwardRef as ReactComponent };